module.exports = new __parcel__URL__("brickfilm.1df794c4.avif").toString();